/**
 * The coin icon set.
 *
 * These are Material Symbols ligature names, which is also what
 * `apps/web/src/images/food_icons/` holds one SVG each of. `coin_programs.icon`
 * stores the **key**, never a path — the manager UI renders it through the
 * already-loaded Material Symbols font (so it inherits `currentColor` and the
 * DaisyUI theme for free), and the receipt renders a PNG derivative of the same
 * SVG source. See docs/plans/loyalty/manager_ui.md §5.
 */
export const COIN_ICON_KEYS = [
  "coffee",
  "local_bar",
  "wine_bar",
  "restaurant",
  "dining",
  "dine_lamp",
  "dinner_dining",
  "lunch_dining",
  "ramen_dining",
  "soba",
] as const;

export type CoinIconKey = (typeof COIN_ICON_KEYS)[number];

/** Rendered when a program has no icon chosen. */
export const DEFAULT_COIN_ICON = "toll";

export const coinIconOf = (icon: string | null | undefined): string =>
  icon && (COIN_ICON_KEYS as readonly string[]).includes(icon)
    ? icon
    : DEFAULT_COIN_ICON;
